// Obsolete
export const onNavigate = () => {
  const navbarToggler = document.body.querySelector('.navbar-toggler');
  const navBar = document.getElementById('navbarResponsive');
  if (navBar?.className.includes("show")) {
    (navbarToggler as any).click();
  }
};